import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgBlockedUserPlaceholderL = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 24,
        cy: 24,
        r: 24,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("circle", {
        cx: 24,
        cy: 24,
        r: 24,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38
      }), /*#__PURE__*/jsx("circle", {
        cx: 24,
        cy: 24,
        r: 21.6,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M30.046 27.61a7.62 7.62 0 0 0 2.458-5.616V17.71a7.657 7.657 0 0 0-7.657-7.656h-1.694a7.657 7.657 0 0 0-7.657 7.656v4.285c0 2.222.947 4.218 2.458 5.616 1.478 1.365 1.42 3.72-.144 4.985a6.2 6.2 0 0 1-1.805 1.018c-2.53.919-5.723 2.271-8.08 3.932a.53.53 0 0 0-.086.78c3.957 4.461 9.729 7.275 16.16 7.275 6.433 0 12.205-2.814 16.162-7.274a.53.53 0 0 0-.087-.78c-2.356-1.662-5.548-3.014-8.08-3.933a6.3 6.3 0 0 1-1.804-1.018c-1.564-1.266-1.622-3.62-.144-4.986"
      }), /*#__PURE__*/jsx("circle", {
        cx: 33.78,
        cy: 32.4,
        r: 7,
        fill: "#9EA0A0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        fillRule: "nonzero",
        d: "M33.78 23.7a8.7 8.7 0 1 1 0 17.4 8.7 8.7 0 0 1 0-17.4m5.53 5.68-8.55 8.55a6.3 6.3 0 0 0 8.55-8.55m-5.53-3.28a6.3 6.3 0 0 0-4.875 10.29l8.866-8.865A6.27 6.27 0 0 0 33.78 26.1"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgBlockedUserPlaceholderL$1 = SvgBlockedUserPlaceholderL;

export { SvgBlockedUserPlaceholderL$1 as default };
